import person1 from '../../assets/img/person1.png';
import person2 from '../../assets/img/person2.png';
import person3 from '../../assets/img/person3.png';


export const TeamList = [
    {
        name: 'James Ash',
        position: "Designer",
        image: person1,
    },
    {
        name: 'Paul Kitty',
        position: "UI/UX Designer",
        image: person2,
    },
    {
        name: 'Sam Smith',
        position: "Designer",
        image: person3,
    },
]